import { render } from "./newHouse.vue?vue&type=template&id=0ebe919f&scoped=true"
import script from "./newHouse.vue?vue&type=script&lang=js"
export * from "./newHouse.vue?vue&type=script&lang=js"

import "./newHouse.vue?vue&type=style&index=0&id=0ebe919f&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebe919f"]])

export default __exports__